<template>
  <div class="custom-box">
    <div class="custom-check">
      <div class="custom-title">
        <div>可选表头<span>（共{{this.allNum}}个）</span></div>
        <el-input
          style="width: 200px;height: 28px;"
          placeholder="搜索"
          v-model="searchText"
          clearable
          @input="getSearchList">
          <i slot="prefix" class="el-input__icon iconhuice icon-a-16"></i>
        </el-input>
      </div>
      <div class="custom-check-main" v-show="searchList.length">
        <div v-for="optional in searchList" :key="optional.id" class="check-box">
          <el-checkbox
            class="check-item check-all-item"
            :value="!!optional.changeNum && optional.changeNum === optional.children.length"
            :indeterminate="!!optional.changeNum && optional.changeNum < optional.children.length"
            @change="(value) => changeAllCheck(value, optional)"
          >
            {{ optional.name }}
          </el-checkbox>
          <div class="check-item-box">
            <el-checkbox
              v-for="item in optional.children"
              class="check-item"
              :key="item.field"
              v-model="item.enable"
              :disabled="!!item.disabled"
              :true-label="1"
              :false-label="0"
              @change="changeItemCheck(item)"
            >
              <span :title="item.label">{{ item.label }}</span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="custom-check-main" v-show="!searchList.length">
        <div style="margin: 30px;text-align: center">暂无搜索内容</div>
      </div>
    </div>
    <div class="wrap-move" v-if="!customColumn.type">
      <div class="custom-title">
        <div>已选表头<span>（可以通过拖动来调整排序）</span></div>
        <div class="custom-clear" @click="clearAll">清空</div>
      </div>
      <div class="wrap-move-main">
        <!-- 冻结项 -->
        <DraggableItem v-for="item in disabledList" :key="item.field" :item-data="item" @update="listClassify" />
        <!-- 已固定 -->
        <draggable v-model="fixedList" v-bind="fixedOptions" @update="updateDraggable">
          <DraggableItem v-for="item in fixedList" :key="item.field" :item-data="item" @update="listClassify" />
        </draggable>
        <div class="xian" />
        <!-- 未固定 -->
        <draggable v-model="unsecuredList" v-bind="unsecuredDragOptions" @update="updateDraggable">
          <DraggableItem v-for="item in unsecuredList" :key="item.field" :item-data="item" :fixedNum="fixedNum" @update="listClassify" />
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { deepCopy } from '@/utils/deep-copy'
import DraggableItem from './draggable-item'
export default {
  components: {
    draggable,
    DraggableItem
  },
  props: {
    customColumn: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      drag: false,
      fixedOptions: {
        animation: 500,
        fallbackTolerance: 2,
        group: 'fixedDescription',
        disabled: false,
        forceFallback: true
      },
      unsecuredDragOptions: {
        animation: 500,
        fallbackTolerance: 2,
        group: 'unsecuredDescription',
        disabled: false,
        forceFallback: true
      },
      searchText: '',
      searchList: [], // 搜索的数据
      optionalList: [], // 左侧全部数据
      editList: [], // 已更改的的数据
      disabledList: [], // 冻结列
      fixedList: [], // 固定列
      unsecuredList: [], // 未固定的列
      unselectedList: [], // 未被选择的列
      minselect: 8, // 最少选择项
    }
  },
  created() {
    this.init()
  },
  watch: {
    optionalList: {
      handler(newVal, oldVal) {
        this.getSearchList()
      },
      immediate: true
    }
  },
  computed: {
    allNum() {
      return this.editList.length
    },
    fixedNum() {
      return this.disabledList.length + this.fixedList.length
    },
    changeAllNum() {
      return this.disabledList.length + this.fixedList.length + this.unsecuredList.length
    }
  },
  methods: {
    init() {
      this.optionalList = deepCopy(this.customColumn.default)
      this.editList = deepCopy(this.customColumn.edit)
      this.getLeftList()
      this.listClassify()
    },
    getLeftList() { // 左侧数据填充
      this.optionalList = this.optionalList.map(optional => {
        return {
          ...optional,
          children: optional.children.map(child => {
            const findObj = this.editList.find(k => k.field === child.field)
            if (findObj) {
              return findObj
            }
            return child
          })
        }
      })
    },
    listClassify() { // 将list分类
      this.$nextTick(() => {
        this.searchList.forEach(item => {
          item.changeNum = item.children.filter(k => k.enable === 1).length
        })
        const disabledList = []
        const fixedList = []
        const unsecuredList = []
        const unselectedList = []
        this.editList.forEach(item => {
          if (item.disabled === 1) {
            disabledList.push(item)
          } else if (item.enable === 1 && item.fixed) {
            fixedList.push(item)
          } else if (item.enable === 1 && !item.fixed) {
            unsecuredList.push(item)
          } else if (item.enable === 0) {
            unselectedList.push(item)
          }
        })
        this.disabledList = disabledList
        this.fixedList = fixedList
        this.unsecuredList = unsecuredList
        this.unselectedList = unselectedList
        this.editList = [...disabledList, ...fixedList, ...unsecuredList, ...unselectedList]
      })
    },
    getSearchList() {
      const searchList = []
      this.optionalList.forEach(optional => {
        const obj = {}
        obj.name = optional.name
        obj.children = optional.children.filter(child => {
          if (child.label.indexOf(this.searchText) !== -1) {
            return true
          }
          return false
        })
        if (obj.children.length) {
          obj.changeNum = obj.children.filter(k => k.enable === 1).length
          searchList.push(obj)
        }
      })
      this.searchList = searchList
    },
    changeItemCheck(item) {
      if (!this.customColumn.type) { // 不属于二级表头类型
        item.fixed = 0
      }
      this.listClassify()
    },
    changeAllCheck(value, item) {
      this.$nextTick(() => {
        item.children.forEach(child => {
          if (!child.disabled) {
            child.enable = value ? 1 : 0
          }
        })
        this.listClassify()
      })
    },
    updateDraggable() {
      this.editList = [...this.disabledList, ...this.fixedList, ...this.unsecuredList, ...this.unselectedList]
    },
    clearAll() { // 清空
      this.editList.forEach(item => {
        if (!item.disabled) {
          item.enable = 0
        }
      })
      this.listClassify()
    },
    async updateData() { // 保存
      if (this.customColumn.minselect && this.changeAllNum < this.customColumn.minselect) {
        this.$message.warning(`${this.customColumn.name || ''}最少选择${this.customColumn.minselect}项表头，请继续选择！`)
        return null
      } else if (!this.customColumn.minselect && this.changeAllNum < this.minselect) {
        this.$message.warning(`${this.customColumn.name || ''}最少选择${this.minselect}项表头，请继续选择！`)
        return null
      }
      const { code } = await this.$request(this.$api.common.editUserDefineRow, {
        ...this.customColumn.params,
        jsonConfig: JSON.stringify(this.editList)
      })
      if (code === 200) {
        return this.editList
      }
      return null
    },
    reset() { // 恢复默认
      const defaultColumnLinearArr = []
      this.customColumn.default.forEach(item => {
        defaultColumnLinearArr.push(...item.children)
      })
      this.optionalList = deepCopy(this.customColumn.default)
      this.editList = deepCopy(defaultColumnLinearArr)
      this.getLeftList()
      this.listClassify()
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-box {
  display: flex;
  // border-bottom: 1px solid #e6e8ed;
  // margin-bottom: 10px;
  // padding-bottom: 20px;
  // max-height: calc(100vh - 230px);
  height: 100%;
  .custom-title{
    color: $G9;
    font-size: 12px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;
    span{
      color: $G6;
    }
    .custom-clear{
      color: $main-color;
      cursor: pointer;
    }
    .icon-a-16{
      font-size: 13px;
      margin-left: 3px;
    }
  }
  .custom-check{
    flex: 1;
    display: flex;
    flex-flow: column;
    .custom-check-main{
      flex: 1;
      overflow-y: auto;
      padding: 12px;
      border-radius: 2px;
      border: 1px solid $G4;
      .check-box{
        margin-top: 16px;
        &:nth-child(-n+1){
          margin-top: 0;
        }
        .check-all-item{
          font-weight: 600;
        }
        .check-item-box{
          background: $G1;
          border-radius: 2px;
          padding: 16px;
          margin-top: 14px;
          display: flex;
          flex-wrap: wrap;
          .check-item{
            display: flex;
            align-items: center;
            width: 30%;
            margin: 16px 2% 0 0;
            &:nth-child(-n+3){
              margin: 0 2% 0 0;
            }
            ::v-deep .el-checkbox__label{
              flex: 1;
              display: block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .wrap-move{
    width: 250px;
    display: flex;
    flex-flow: column;
    margin-left: 16px;
    .wrap-move-main{
      flex: 1;
      overflow-y: auto;
      padding: 4px 12px 12px 12px;
      border-radius: 2px;
      border: 1px solid $G4;
      .xian{
        margin-top: 8px;
        height: 1px;
        background-color: $G3;
      }
    }
  }
}
.footer{
  display: flex;
  justify-content: space-between;
}
.mr19{
  margin-right: 19px;
}
</style>
